import React from 'react';
import '../assets/styles/Education.scss';

function Education() {
  return <section className="section shell" id="education" aria-labelledby="education-title">
    <div className="section-heading"><span className="section-number">05 /</span><h2 id="education-title">Education</h2></div>
    <div className="education-row"><p className="eyebrow">2019–2023</p><div><h3>Nanyang Technological University, Singapore</h3><p>Bachelor of Engineering (Honours), Computer Engineering</p><p className="muted">Academic focus: Data Science & Artificial Intelligence</p></div></div>
  </section>;
}
export default Education;
